/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarContact_item = {
    readonly isCustomizable: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedRequestHold_item" | "PdpSharedContactDealerButton_item" | "PdpSharedMakeOfferButton_item" | "PdpSharedContactSupportButton_item">;
    readonly " $refType": "PdpRespSidebarContact_item";
};
export type PdpRespSidebarContact_item$data = PdpRespSidebarContact_item;
export type PdpRespSidebarContact_item$key = {
    readonly " $data"?: PdpRespSidebarContact_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarContact_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarContact_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCustomizable",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRequestHold_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSupportButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'c6398452781e034901c582a7725f2e9b';
export default node;
